document.addEventListener('DOMContentLoaded', () => {
  const mainImage = document.getElementById('ProductMainImage');
  const thumbs = document.querySelectorAll('.product_thumb');

  thumbs.forEach((thumb) => {
    thumb.addEventListener('click', () => {
      const newSrc = thumb.dataset.image;
      const newAlt = thumb.dataset.alt || '';

      if (mainImage) {
        mainImage.classList.add('is-fading');

        setTimeout(() => {
          mainImage.src = newSrc;
          mainImage.alt = newAlt;

          mainImage.classList.remove('is-fading');
        }, 200);
      }

      thumbs.forEach((item) => item.classList.remove('is-active'));
      thumb.classList.add('is-active');
    });
  });
});